(() => {
  if (customElements.get('auriani-product-card')) return;
  class AurianiProductCard extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-card-variant]');
        if (!button || !this.contains(button)) return;
        this.querySelectorAll('[data-card-variant]').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
        this.querySelectorAll('a[data-analytics-product-id]').forEach(link => {
          const url = new URL(link.href, location.origin);
          url.searchParams.set('variant', button.dataset.cardVariant);
          link.href = url.href;
          link.dataset.analyticsVariantId = button.dataset.cardVariant;
        });
        const price = this.querySelector('[data-card-price]');
        if (price) price.textContent = button.dataset.cardPriceValue;
        const image = this.querySelector('.catalog-card__image img');
        if (image && button.dataset.cardImage) {
          image.removeAttribute('srcset');
          image.src = button.dataset.cardImage;
        }
      }, {signal: this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('auriani-product-card', AurianiProductCard);
})();
